import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../design-system/cards/Card';
import { HeadingSub } from '../../design-system/Headings';
import Paragraph from '../../design-system/Paragraph';
import LockedContent from '../LockedContent';

import careersType from '../../proptypes/careers';
import DashboardButton from '../../pages/Dashboard/DashboardButton';

const DashboardCareersCard = ({
  title,
  footer,
  careers,
  locked,
  onButtonClick,
}) => (
  <Card h100>
    <Card.Header>{title}</Card.Header>
    <Card.Body h100 dFlex>
      <LockedContent locked={locked}>
        <div className="row careers sm-careers--alternate md-careers--alternate lg-careers--2x2 xl-careers--2x2">
          {careers.map(({ title: roleTitle, description: roleDescription }) => (
            <div className="career col-lg-6 col-12 my-4" key={roleTitle}>
              <div className="content">
                <HeadingSub>{roleTitle}</HeadingSub>
                <Paragraph my0 className="ss_sm-hide">
                  {roleDescription}
                </Paragraph>
              </div>
            </div>
          ))}
        </div>
      </LockedContent>
    </Card.Body>
    <Card.Footer>
      <DashboardButton
        onClickLocked={onButtonClick}
        locked={locked}
        href={footer.buttonLink}
        secondary
        my0
      >
        {footer.buttonText}
      </DashboardButton>
    </Card.Footer>
  </Card>
);

DashboardCareersCard.propTypes = {
  locked: PropTypes.bool,
  title: PropTypes.string.isRequired,
  careers: careersType.isRequired,
  footer: PropTypes.exact({
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
  }).isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

DashboardCareersCard.defaultProps = {
  locked: false,
};

export default DashboardCareersCard;
